import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

var QuickFilterButton = (_param)=>{
    var { className , active , label , ariaLabels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "active",
        "label",
        "ariaLabels"
    ]);
     return React.createElement(Button, swcHelpers.extends({}, rest, {
        className: classnames('quick-filter-button', {
            'quick-filter-button--active': active
        }, className),
        variant: "outline",
        "aria-label": active ? ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.active : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.inactive
    }), /*#__PURE__*/ React.createElement("span", {
        className: "quick-filter-button__text"
    }, label), active && /*#__PURE__*/ React.createElement(Icon, {
        className: "quick-filter-button__icon",
        name: "close"
    }));
};

export { QuickFilterButton, QuickFilterButton as default };
//# sourceMappingURL=QuickFilterButton.js.map
